import { createFileRoute } from "@tanstack/react-router";
import { SharedViewPage } from "@/modules/sharing/presentation/pages/SharedViewPage";

export const Route = createFileRoute("/shared/$token")({
  component: () => {
    const { token } = Route.useParams();
    return <SharedViewPage token={token} />;
  },
});
